import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { ReadWebToastsMutationRequest, ReadWebToastsMutationResponse } from "../../types/ReadWebToasts";

/**
     * @summary Вернуть для конкретного пользователя все не прочитанные Web Toast(всплывающие уведомления) и отметить как прочтённые
     * @link /api/webToasts/do_read
     */
export async function readWebToasts (data?: ReadWebToastsMutationRequest, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<ReadWebToastsMutationResponse>["data"]> {
    const { data: resData } = await client<ReadWebToastsMutationResponse, ReadWebToastsMutationRequest>({
        method: "post",
        url: `/api/webToasts/do_read`,
        data,
        ...options
    });
    
    return resData;
};